import { Injectable } from "@angular/core";
import { PlatformApiWpService } from "./platform-apiwp.service";
import { CommonConfig } from "../shared/common-config/common-config";
import { TokenService } from "./token.service";
import { Observable, catchError, pipe, throwError } from "rxjs";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { EventInteractionService } from "@mare-common/ngx-mare-common";
import { ProductService } from "./product.service";

export class CartElement {
    name?: string;
    price?: number;
    sku!: string;
    pid?: number;
    variationSku?: string;
    options?: any;
    params?: any;
    bundleName?: any;
    bundleImage?: any;
    bundleDescription?: any;
    cik?: string;
}

export interface CartTotals {
    totalcart: number;
    subtotal: number;
    discountApplied?: {
        couponCode: string,
        discount: number,
        discountTax: number
    }[];
}

declare var window: any;

@Injectable({
    providedIn: 'root'
})
export class CartService {
    checkoutRedirect: any;
    currentCart: Array<CartElement> = [];
    cartConfig!: { useLocalCart: boolean, useRemoteCart: boolean, useLocalCartPage: boolean };

    vat: number = 0.22;
    currentCartSummary!: CartTotals;

    constructor(
        private platformApiWpService: PlatformApiWpService,
        private configService: CommonConfig,
        private tokenService: TokenService,
        private router: Router,
        private eventInteractionService: EventInteractionService,
        private productService: ProductService
    ) {
        this.checkoutRedirect = this.configService.getFromConfig('checkoutRedirect');
        const cartConfig = this.configService.getFromConfig('cartConfig');
        if (typeof cartConfig == 'object') {
            this.cartConfig = cartConfig;
        } else if (typeof cartConfig == 'string') {
            this.cartConfig = JSON.parse(cartConfig);
        }
        if (this.cartConfig.useLocalCart) {
            this.checkoutRedirect = false;
        }
        this.currentCart = this.getCartFromStorage();
    }


    /**
     * Opens a popup window and checks if popups are blocked. 
     * If blocked, displays an alert message. 
     *
     * @return {boolean} true if popup opened successfully, false otherwise
     */
    checkPopup(): boolean {
        const width = 10;
        const height = 10;
        const left = window.screen.width;
        const top = window.screen.height;

        const popup = window.open("", "", `width=${width},height=${height},left=${left},top=${top},scrollbars=no,resizable=no,status=no,toolbar=no,menubar=no,location=no`);

    
        if (popup === null || typeof popup === "undefined") {
          alert("I popup sono bloccati. Per favore, abilitali per continuare.");
          return false;
        } else {
          popup.close();
          return true;
        }
      }

    /**
     * Place an order using Paypal.
     *
     * @param {any} params - parameters for placing the order ex. {'piva': '07784980638', 'sdi': 'pluto'}
     * @return {Promise} a Promise that resolves with the response or rejects with an error
     */
    placeOrderByPaypal(params: any) {
        return new Promise((resolve, reject) => {
            if (this.currentCart.length == 0) {
                reject('empty cart');
            }

            let data = {
                'products': new Array<any>(),
                'orderType': 'product',
                'params': params
            }

            this.currentCart.forEach(element => {
                data.products.push({
                    'productSku': element.sku,
                    'variationSku': element.variationSku
                });
            });
            // this.platformApiWpService.postRequest('/msc/v1/checkout', data).then((sub: any) => {
            //     sub.subscribe((response: any) => {
            //         resolve(response);
            //     });
            // }).catch((err) => {
            //     reject(err);
            // });
            this.platformApiWpService.postRequest('/msc/v1/wccheckout', data).then((sub: any) => {
                sub.subscribe((response: any) => {
                    this.platformApiWpService.postRequest('/msc/v1/orderCheckout', {
                        oid: response.payload
                    }).then((sub: any) => {
                        sub.subscribe((response: any) => {

                            resolve(response);
                        });
                    }).catch((err) => {
                        reject(err);
                    });
                });
            }).catch((err) => {
                reject(err);
            });
        })
    }

    orderAcceptance(orderId: string) {

        return new Promise((resolve, reject) => {
            if (!orderId) {
                reject('no order id');
                return;
            }

            this.platformApiWpService.postRequest('/msc/v1/orderAcceptance', { 'oid': orderId }).then((sub: any) => {
                sub.subscribe((response: any) => {
                    resolve(response);
                });
            }).catch((err) => {
                reject(err);
            });
        });
    }

    manageOrder(orderId: string) {
        return new Promise((resolve, reject) => {
            if (!orderId) {
                reject('no order id');
                return;
            }

            this.platformApiWpService.postRequest('/msc/v1/orderCheckout', { 'oid': orderId }).then((sub: any) => {
                sub.subscribe((response: any) => {
                    resolve(response);
                });
            }).catch((err) => {
                reject(err);
            });
        });
    }

    getReportByPaypal(piva?: string, sku: string = 'report-digitale', variationSku: string = 'report-digitale-medium', orderType: string = 'report') {

        return new Promise((resolve, reject) => {

            // console.log("getReport");
            const data = {
                'products': [{
                    'productSku': sku,
                    'variationSku': variationSku,
                    //'price':  da reucperare nella variation
                    //'num_report':  da recuperare dall attr
                }
                ],
                // 'customer_id': 8,
                // 'company_id': 11280,
                'orderType': orderType,
                // 'price': 1
                'params': {
                    'piva': piva
                }
            }
            this.platformApiWpService.postRequest('/msc/v1/checkout', data).then((sub: any) => {
                sub.subscribe((response: any) => {
                    resolve(response);
                });
            }).catch((err) => {
                reject(err);
            });
        })

    }

    checkout(redirect?: boolean, piva?: string) {
        if (redirect == undefined || redirect == null) {
            redirect = this.checkoutRedirect;
        }
        if (this.cartConfig.useLocalCartPage) {
            this.router.navigate([environment.routingBasePath + '/cart']);
            return new Promise((resolve, reject) => {
                resolve(true);
            });
        }
        if (redirect) {
            return new Promise((resolve, reject) => {
                let access_token = this.tokenService.getAccessToken();
                // const url = 'https://servicecompany.maredigital.it/sso?access_token=' + access_token + "&redirect_to=https://servicecompany.maredigital.it/carrello"
                ;
                const url = this.configService.getBaseUrl() + '/sso?access_token=' + access_token + "&redirect_to=https://servicecompany.maredigital.it/pagamento/&scope=checkout"
                resolve(true);
                window.open(url, '_self')
            })
        } else {
            return this.getReportByPaypal(piva);
        }
    }

    makeWcCheckout() {

        return new Promise((resolve, reject) => {

            // console.log("getReport");
            const data = {
            }
            this.platformApiWpService.postRequest('/msc/v1/wccheckout', data).then((sub: any) => {
                sub.subscribe((response: any) => {
                    resolve(response);
                });
            }).catch((err) => {
                reject(err);
            });
        })

    }

    addCoupon(couponCode: string) {

        return new Promise((resolve, reject) => {

            // console.log("getReport");
            const data = {
                couponCode
            }
            this.platformApiWpService.postRequest('/msc/v1/addCoupon', data).then((sub: any) => {
                sub.subscribe((response: any) => {
                    resolve(response);
                });
            }).catch((err) => {
                reject(err);
            });
        })

    }

    removeCoupon(couponCode: string) {

        return new Promise((resolve, reject) => {

            // console.log("getReport");
            const data = {
                couponCode
            }
            this.platformApiWpService.postRequest('/msc/v1/removeCoupon', data).then((sub: any) => {
                sub.subscribe((response: any) => {
                    resolve(response);
                });
            }).catch((err) => {
                reject(err);
            });
        })

    }
    
    saveCartInStorage(cart: CartElement[] | CartElement ) {
        localStorage.setItem('cart', JSON.stringify(cart));
    }
    updateCartInStorage() {
        localStorage.setItem('cart', JSON.stringify(this.currentCart));
    }
    getCartFromStorage() {
        return JSON.parse(localStorage.getItem('cart') || '[]');
    }

    // setCurrentCart(cart: CartElement) {
    //     this.currentCart.push(cart)
    // }
    // updateCurrentCart(cart: any) {
    //     // this.currentCart = [...this.currentCart, ...cart]
    //     this.currentCart = [...cart]
    // }
    getLocalCart() {
        return new Promise<CartElement[]>((resolve, reject) => {
            resolve(this.currentCart)
        })
        // return this.currentCart
    }
    emptyCart(callback?: () => void) {
        let ret: Promise<any> | null = null;
        if (this.cartConfig.useLocalCart) {
            ret = this.emptyLocalCart();
        }
        if (this.cartConfig.useRemoteCart) {
            let retRem = this.emptyRemoteCart();
            if (ret == null)
                ret = retRem;
        }
        if (ret == null) {
            ret = new Promise((resolve, reject) => {
                reject('config error...');
            })
        }
        if (callback) {
            callback();
        }
        return ret;
    }
    emptyLocalCart() {
        return new Promise((resolve, reject) => {
            this.currentCart = [];
            this.updateCartInStorage();
            resolve(this.currentCart)
        })
    }

    checkProducts() {
        return new Promise((resolve, reject) => {
            if (!this.productService.allProducts || this.productService.hasVariations != true) {
                this.productService.retrieveAllProducts({
                    getVariations: true
                }).then(() => {
                    resolve(true);
                })
            } else {
                resolve(true);
            }
        })
    }

    emptyRemoteCart() {

        return new Promise(async (resolve, reject) => {

            await this.checkProducts();
            this.platformApiWpService.postRequest('/msc/v1/emptyCart', {}).then((sub: Observable<unknown>) => {
                sub
                    .pipe(
                        catchError((err: any) => {
                            reject(err);
                            console.log(err);
                            return err;
                        })
                    )
                    .subscribe((response: any) => {
                        resolve(this.convertRemoteCart(response));
                    });
            }).catch((err) => {
                reject(err);
            });
        })
    }


    addToCart(params: CartElement, emptyCart: boolean = true) {
        // this.eventInteractionService.publishData({ event: 'addToCart', data: params });
        return new Promise(async (resolve, reject) => {
            if (emptyCart) {
                if (this.cartConfig.useLocalCart)
                    await this.emptyLocalCart();
                if (this.cartConfig.useRemoteCart) {
                    await this.emptyRemoteCart();
                }
            }

            let ret: Promise<any> | null = null;
            if (this.cartConfig.useLocalCart) {
                ret = this.addToLocalCart(params);
            }
            if (this.cartConfig.useRemoteCart) {
                const remRet = this.addToRemoteCart(params);
                if (ret == null)
                    ret = remRet;
            }
            if (ret == null) {
                reject('config error...');
            }
            ret?.then((res) => {
                resolve(res);
            }).catch((err) => {
                reject(err);
            })
            // resolve(ret);
        })

    }

    removeFromCart(params: CartElement) {
        // this.eventInteractionService.publishData({ event: 'removeFromCart', data: params });
        let ret: Promise<any> | null = null;
        if (this.cartConfig.useLocalCart) {
            ret = this.removeFromLocalCart(params);
        }
        if (this.cartConfig.useRemoteCart) {
            const remRet = this.removeFromRemoteCart(params);
            if (ret == null)
                ret = remRet;
        }
        if (ret == null) {
            ret = new Promise((resolve, reject) => {
                reject('config error...');
            })
        }
        return ret;
    }

    removeFromLocalCart(params: CartElement) {

        return new Promise((resolve, reject) => {
            if (!params.pid && !params.sku) {
                reject('no pid or sku');
                return
            }
            this.currentCart = this.currentCart.filter((item) => {
                if (params.pid) {
                    return item.pid != params.pid
                } else {
                    return item.sku != params.sku
                }
            });

            this.updateCartInStorage();
            this.eventInteractionService.publishData({ event: 'removeFromCart', data: params });
            resolve(this.currentCart)
        })
    }

    removeFromRemoteCart(params: CartElement) {

        return new Promise(async (resolve, reject) => {
            if (!params.pid && !params.sku) {
                reject('no pid or sku');
                return
            }
            await this.checkProducts();
            this.platformApiWpService.postRequest('/msc/v1/removeFromCart', params).then((sub: Observable<unknown>) => {
                sub
                    .pipe(
                        catchError((err: any) => {
                            reject(err);
                            console.log(err);
                            return err;
                        })
                    )
                    .subscribe((response: any) => {
                        resolve(this.convertRemoteCart(response));
                    });
            }).catch((err) => {
                reject(err);
            });
        })
    }

    addToLocalCart(params: CartElement) {

        return new Promise((resolve, reject) => {
            if (!params.pid && !params.sku) {
                reject('no pid or sku');
                return
            }
            let curEl = null;
            if (params.pid) {
                curEl = this.currentCart.find((item) => item.pid == params.pid);
            } else {
                curEl = this.currentCart.find((item) => item.sku == params.sku);
            }
            if (curEl) {
                this.currentCart.splice(this.currentCart.indexOf(curEl), 1);
            }

            this.currentCart.push(params);
            this.updateCartInStorage();
            this.eventInteractionService.publishData({ event: 'addToCart', data: params });
            resolve(this.currentCart);
        })
    }
    addToRemoteCart(params: CartElement) {

        return new Promise(async (resolve, reject) => {
            if (!params.pid && !params.sku) {
                reject('no pid or sku');
                return
            }

            await this.checkProducts();

            // let data: any = {

            // }
            // if(params.pid) {
            //     data.pid = params.pid;
            // } else {
            //     data.sku = params.sku;
            // }
            // if(params.options) {
            //     data.params = params.options
            // }
            // {
            //     pid: 11300,
            //     params: {
            //         piva: '07784980638',
            //         pippo: 'pluto',
            //         thwepof_options: {
            //             piva: {
            //                 name: 'piva',
            //                 value: '07784980638',
            //                 type: "inputtext",
            //                 label: 'Partita IVA',
            //                 options: ''
            //             }
            //         }
            //     }
            // }

            this.platformApiWpService.postRequest('/msc/v1/addToCart', params).then((sub: Observable<unknown>) => {
                sub
                    .pipe(
                        catchError((err: any) => {
                            reject(err);
                            console.log(err);
                            return throwError(()=>err);
                        })
                    )
                    .subscribe((response: any) => {
                        // resolve(this.convertRemoteCart(response));
                        this.currentCart = this.convertRemoteCart(response);
                        this.convertCartSummary(response);
                        resolve(this.currentCart);
                    });
            }).catch((err) => {
                reject(err);
            });
        })

    }

    getCart(): Promise<CartElement[]> {
        if (this.cartConfig.useLocalCart) {
            return this.getLocalCart();
        } else {
            if (!this.productService.allProducts || this.productService.hasVariations != true) {
                return new Promise((resolve, reject) => {
                    this.productService.retrieveAllProducts({
                        getVariations: true
                    }).then(() => {
                        this.getRemoteCart().then((v) => {
                            resolve(v);
                        }).catch((ex) => {
                            reject(ex);
                        })
                    }).catch((ex) => {
                        reject(ex);
                    })
                })
            }
            return this.getRemoteCart();
        }
    }
    getRemoteCart() {
        return new Promise<CartElement[]>(async (resolve, reject) => {
            await this.checkProducts();
            this.platformApiWpService.getRequest('/msc/v1/getCart').then((sub: Observable<any>) => {
                sub
                    .pipe(
                        catchError((err: any) => {
                            reject(err);
                            console.log(err);
                            return err;
                        })
                    )
                    .subscribe((response: any) => {
                        this.currentCart = this.convertRemoteCart(response);
                        this.convertCartSummary(response);
                        resolve(this.currentCart);
                    });
            }).catch((err) => {
                reject(err);
            });
        })

    }
    convertCartSummary(response: any): Promise<CartTotals> {
        return new Promise<CartTotals>((resolve, reject) => {
            this.calculateTotals(this.currentCart).then((ct) => {
                this.currentCartSummary = ct;
                if (response && response.payload && response.payload.applied_coupons) {
                    this.currentCartSummary.discountApplied = [];
                    for (const couponCode of response.payload.applied_coupons) {
                        this.currentCartSummary.discountApplied.push({
                            couponCode: couponCode,
                            discount: response.payload.coupon_discount_totals[couponCode],
                            discountTax: response.payload.coupon_discount_tax_totals[couponCode],
                        })
                        ct.subtotal -= response.payload.coupon_discount_totals[couponCode];
                        ct.totalcart = ct.totalcart - response.payload.coupon_discount_totals[couponCode] - response.payload.coupon_discount_tax_totals[couponCode]
                    }
                }
                this.currentCartSummary = ct;
            })
        });
    }



    convertRemoteCart(data: any): CartElement[] {
        // TODO implementare la funzione per convertire il remote cart in un local cart
        if (!data || !data.payload)
            return [];
        const ret = [];
        for (const key in data.payload.cart_contents) {
            if (Object.prototype.hasOwnProperty.call(data.payload.cart_contents, key)) {
                const lineElement = data.payload.cart_contents[key];
                let le = this.convertLineElement(lineElement);
                if (le){
                    le.cik = key;
                    ret.push(le);
                }
            }
        }
        return ret;
    }

    convertLineElement(lineElement: any): CartElement | null {
        if (!lineElement)
            return null;
        const el = this.productService.allProducts.find((p) => {
            if (p.id == lineElement.product_id) {
                if (lineElement.variation_id && lineElement.variation_id > 0 && p.variations) {
                    const found = p.variations.find((pv: any) => {
                        return pv.id == lineElement.variation_id;
                    })
                    return !!found;
                } else {
                    return true;
                }
            }
            return false;
        });
        if (!el)
            return null;

        let variation: any = null;
        if (lineElement.variation_id && lineElement.variation_id > 0 && el.variations) {
            variation = el.variations.find((pv: any) => {
                return pv.id == lineElement.variation_id;
            })
        }

        const attributesKey = (variation && Object.keys(variation.attributes)[0]) ?? 'pa_bundle-report';
        return {
            pid : lineElement.product_id,
            name: variation ? variation.attributes[attributesKey].name : el.name,
            price: lineElement.line_subtotal,
            // sku: 'report-digitale',
            sku: el.sku,
            // variationSku: 'report-digitale-' + plan.slug,
            variationSku: variation ? variation.sku : null,
            bundleName: el.name,
            bundleImage: el.image_url ?? null,
            bundleDescription: variation ? variation.variation_description : el.description,
            params: {
                thwepof_options: lineElement.thwepof_options
            }
        }

    }

    getCurrentCartSummary(): Promise<CartTotals> {
        return new Promise<CartTotals>((resolve, reject) => {
            if (this.currentCartSummary) {
                resolve(this.currentCartSummary);
                return;
            }
            this.getRemoteCart().then((v) => {
                resolve(this.currentCartSummary);
            }).catch((ex) => {
                reject(ex);
            })
        })
    }

    calculateTotals(products: any[]): Promise<CartTotals> {
        return new Promise((resolve) => {
            let totals: CartTotals
            if (!products) {
                totals = {
                    totalcart: 0,
                    subtotal: 0
                }
            } else {
                let subtotal = products.reduce((a: any, b: any) => a + b.price, 0);
                let totalCart = subtotal * (1 + this.vat);
                totals = {
                    totalcart: totalCart,
                    subtotal: subtotal
                }
            }
            resolve(totals)
        })
    }

    getAcceptanceTerms(productsku: string | string[], type: 'full' | 'splitted' | 'light' | 'generic', priceToReplace: string | number, offerToReplace?: number | string): Promise<any> {
        return new Promise((resolve, reject) => {
            let tec = 'termini-e-condizioni-';
            if (productsku && typeof productsku == 'string') {
                tec += productsku;
            } else if (productsku && typeof productsku == 'object') {
                // TODO gestire acceptance multiple
                tec = 'termini-e-condizioni'
            }

            if (type == "splitted") {
                tec += '-splitted';
            }
            this.platformApiWpService.getRequest('/msc/v1/getPage?name=' + tec).then((sub: any) => {
                sub.pipe(
                    catchError((err: any) => {
                        reject(err);
                        console.error('Pagina wp ' + tec + ' non trovata', err);
                        return err;
                    })
                ).subscribe((res: any) => {
                    if (res && res.status == 'ok')
                        // console.log(res.payload);
                        // fin string enclosed in square barackets [price] and replace with priceToReplace

                        res.payload = res.payload.replace("[price]", priceToReplace + " euro");
                    if (type == 'splitted' && offerToReplace) {
                        res.payload = res.payload.replace("[offer]", offerToReplace + " euro");
                    }

                    resolve(res.payload);
                })

            }, (err: any) => {
                reject(err)
            })
        })

    }




}